import Vue from 'vue'
import {
  Button,
  Field,
  Form,
  Tabbar,
  TabbarItem,
  NavBar,
  Cell,
  CellGroup,
  Image as VanImage,
  ImagePreview,
  Icon,
  Search,
  List,
  Tag,
  Popup,
  Dialog,
  Toast,
  Notify,
  Uploader,
  Grid,
  GridItem,
  Divider,
  Empty,
  Loading,
  Overlay,
  Switch,
  Swipe,
  SwipeItem,
  ActionSheet,
  DatetimePicker,
  Tabs,
  Tab
} from 'vant'

Vue.use(Button)
Vue.use(Field)
Vue.use(Form)
Vue.use(Tabbar)
Vue.use(TabbarItem)
Vue.use(NavBar)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(VanImage)
Vue.use(ImagePreview)
Vue.use(Icon)
Vue.use(Search)
Vue.use(List)
Vue.use(Tag)
Vue.use(Popup)
Vue.use(Dialog)
Vue.use(Uploader)
Vue.use(Grid)
Vue.use(GridItem)
Vue.use(Divider)
Vue.use(Empty)
Vue.use(Loading)
Vue.use(Overlay)
Vue.use(Switch)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(ActionSheet)
Vue.use(DatetimePicker)
Vue.use(Tabs)
Vue.use(Tab)

Vue.prototype.$toast = Toast
Vue.prototype.$notify = Notify
Vue.prototype.$dialog = Dialog
